class Cookie {
  static create(name, value, days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      var expires = "; expires=" + date.toGMTString();
    } else {
      var expires = "";
    }
    var cookie = name + "=" + value + expires + ";path=/;SameSite=None; Secure";
    document.cookie = cookie;
  }

  static read(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) == 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  }

  static exists(name) {
    return this.read(name) !== null;
  }

  static erase(name) {
    this.create(name, "", -1);
  }
}

export default Cookie;



// WEBPACK FOOTER //
// ./lib/Cookie.js